import React from 'react';
import Footer from '../Home/Footer/Footer';
import Navbar from '../Home/Navbar/Navbar';
import Blog from './Blog/Blog';

const Blogs = () => {
    return (
        <>
           <Navbar />
           <Blog />
           <Footer /> 
        </>
    );
};

export default Blogs;